import { render, staticRenderFns } from "./LiveloPointsRuleEditModal.vue?vue&type=template&id=07c1ca90&"
import script from "./LiveloPointsRuleEditModal.vue?vue&type=script&lang=js&"
export * from "./LiveloPointsRuleEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports